// extracted by mini-css-extract-plugin
module.exports = {"headers":"header_headers__5ZiTt","border_bottom":"header_border_bottom__DCtki"};